// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '60185db8-a7f6-472d-90cd-7f54f95b45a4',
      type: 'Sprite',
      name: 'backgroundImage',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Image_Magic_Forest',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '62c68830-fca6-4283-8a50-81acdbedc177',
      type: 'Container',
      name: 'particles',
      className: '',
      x: 0,
      y: 20,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'f7e4d550-10a5-438d-b4f9-79e2e20f170b',
      type: 'Sprite',
      name: 'glow',
      className: '',
      x: 0,
      y: 140,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3,
        y: 3
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 9568253,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Glow_Half',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '413166d6-3b94-475a-8074-e3af44d1b7ed',
      type: 'Sprite',
      name: 'rays',
      className: 'rotate_SPL',
      x: 0,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        rotationCycle: 40000
      }
    },
    {
      id: '7a69218d-4f5b-4818-8a9e-ef0353587ae5',
      type: 'Sprite',
      name: 'stack',
      className: '',
      x: 0,
      y: 190,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Purple_Stack',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '3b6b6a93-b652-4c70-a170-9364e7608b2b',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '7be90b4f-02f5-4f62-b5e8-4b4ed10dd9d1',
      type: 'Sprite',
      name: 'icon',
      className: '',
      x: 0,
      y: 40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Collect_Event_Icon_Unicorn',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'ef5df523-f4ef-4d61-8214-fd3f14882e58',
      type: 'Sprite',
      name: 'sparkle1',
      className: '',
      x: 0,
      y: -30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Sparkle',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'dfb7f111-a1d4-49f8-a4b3-318c297d873c',
      type: 'Sprite',
      name: 'sparkle2',
      className: '',
      x: -70,
      y: 49,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Sparkle',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'afeea85a-22db-44c7-ac66-ab659322fce0',
      type: 'Sprite',
      name: 'sparkle3',
      className: '',
      x: 35,
      y: 120,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2,
        y: 2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Sparkle',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  animations: [
    {
      id: '089e92b3-6529-4b42-898f-535f5c2d49d1',
      name: 'idle',
      playingSpeed: 1,
      totalDuration: 3000,
      blocks: [
        {
          id: 'e30cb0b2-ead4-49f4-879f-78e20c82eaa5',
          type: 'Setter',
          name: 'FXPART_Collect_Event_Particle',
          track: 2,
          target: {},
          startAt: 0,
          sourceName: 'particles',
          disabled: false
        },
        {
          id: 'b6cee5c2-b5ac-446d-a07a-e71a6c8964a8',
          type: 'Tween',
          name: 'icon',
          duration: 1500,
          track: 1,
          target: {
            y: 25,
            scale: {
              x: 0.97
            }
          },
          startAt: 0,
          sourceName: 'icon',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'da97b723-a01c-46e1-94bb-8982258caf14',
          type: 'Setter',
          name: 'sparkle1',
          track: 3,
          target: {
            scale: {
              x: 2,
              y: 2
            },
            alpha: 1
          },
          startAt: 300,
          sourceName: 'sparkle1',
          disabled: false
        },
        {
          id: 'fffc2a73-cbf6-460a-9aa0-65a377d5bcc9',
          type: 'Tween',
          name: 'sparkle1_1',
          duration: 120,
          track: 3,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 310,
          sourceName: 'sparkle1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0669caaa-ca20-4e8d-b785-3bf2ea3bc31f',
          type: 'Setter',
          name: 'sparkle1',
          track: 3,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 430,
          sourceName: 'sparkle1',
          disabled: false
        },
        {
          id: 'f7d25cb7-4ddd-42c8-81bf-d352bc2a0558',
          type: 'Setter',
          name: 'sparkle2',
          track: 4,
          target: {
            scale: {
              x: 2,
              y: 2
            },
            alpha: 1
          },
          startAt: 500,
          sourceName: 'sparkle2',
          disabled: false
        },
        {
          id: '2f8eb70d-45da-4b9a-8d30-714c895cf6c2',
          type: 'Tween',
          name: 'sparkle2_1',
          duration: 120,
          track: 4,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 510,
          sourceName: 'sparkle2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'fb2fc34a-9c0e-47d1-89f3-dc8289dafe11',
          type: 'Setter',
          name: 'sparkle2',
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 630,
          sourceName: 'sparkle2',
          disabled: false
        },
        {
          id: 'ce72f2bf-4f55-4e3d-ba2d-a1015d06869e',
          type: 'Setter',
          name: 'sparkle3',
          track: 5,
          target: {
            alpha: 1,
            scale: {
              x: 2,
              y: 2
            }
          },
          startAt: 700,
          sourceName: 'sparkle3',
          disabled: false
        },
        {
          id: '54bedf3b-2161-40ce-a208-850f684f2a3f',
          type: 'Tween',
          name: 'sparkle3_1',
          duration: 120,
          track: 5,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 710,
          sourceName: 'sparkle3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5f8d3e1c-4df1-44fa-88ee-70c80b88db2e',
          type: 'Setter',
          name: 'sparkle3',
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 830,
          sourceName: 'sparkle3',
          disabled: false
        },
        {
          id: '92b49739-ec3c-4421-85a9-6dbc8cf27362',
          type: 'Tween',
          name: 'icon_1',
          duration: 1500,
          track: 1,
          target: {
            y: 40,
            scale: {
              x: 1
            }
          },
          startAt: 1500,
          sourceName: 'icon',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3b8a2118-083f-45a8-bcb5-213e3ec54680',
          type: 'Setter',
          name: 'sparkle3_copy',
          track: 5,
          target: {
            alpha: 1,
            scale: {
              x: 2,
              y: 2
            }
          },
          startAt: 1800,
          sourceName: 'sparkle3',
          disabled: false
        },
        {
          id: '9e49d440-f8b6-4301-821e-aa28ce41bcb0',
          type: 'Tween',
          name: 'sparkle3_1_copy',
          duration: 120,
          track: 5,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 1810,
          sourceName: 'sparkle3',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '3acac4e3-a214-454d-9969-361d09c3152f',
          type: 'Setter',
          name: 'sparkle3',
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 1930,
          sourceName: 'sparkle3',
          disabled: false
        },
        {
          id: '55465506-5007-4626-9a0c-da0bf7ec0517',
          type: 'Setter',
          name: 'sparkle2_copy',
          track: 4,
          target: {
            scale: {
              x: 2,
              y: 2
            },
            alpha: 1
          },
          startAt: 2000,
          sourceName: 'sparkle2',
          disabled: false
        },
        {
          id: '5a19a4e9-82c0-4220-86f7-dabc303a1560',
          type: 'Tween',
          name: 'sparkle2_1_copy',
          duration: 120,
          track: 4,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 2010,
          sourceName: 'sparkle2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5cd5d7ad-ff3d-46b0-b0e5-b0bf77638e30',
          type: 'Setter',
          name: 'sparkle2_copy_1',
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 2130,
          sourceName: 'sparkle2',
          disabled: false
        },
        {
          id: '6a77f7a7-1b14-42e9-97f4-c691081f128e',
          type: 'Setter',
          name: 'sparkle1_copy',
          track: 3,
          target: {
            scale: {
              x: 2,
              y: 2
            },
            alpha: 1
          },
          startAt: 2200,
          sourceName: 'sparkle1',
          disabled: false
        },
        {
          id: '664b32a7-e032-4996-a302-e8326c376fd1',
          type: 'Tween',
          name: 'sparkle1_1_copy',
          duration: 120,
          track: 3,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 2210,
          sourceName: 'sparkle1',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0c935e12-72da-4403-a5e6-ad3feed3f6b4',
          type: 'Setter',
          name: 'sparkle1_copy_1',
          track: 3,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 2330,
          sourceName: 'sparkle1',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class CollectEventMagicSpellImageLayout {
  static raw = raw;
  root!: Container;
  backgroundImage!: Sprite;
  particles!: Container;
  glow!: Sprite;
  rays!: Sprite & { data: typeof raw['list'][4]['data'] };
  stack!: Sprite;
  icon!: Sprite;
  sparkle1!: Sprite;
  sparkle2!: Sprite;
  sparkle3!: Sprite;
  rotate_SPL!: (Sprite & { data: typeof raw['list'][4]['data'] })[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class idle {
  Layout: {
    particles: object;
    icon: object;
    sparkle1: object;
    sparkle2: object;
    sparkle3: object;
  };

  BlockTypeByName: {
    FXPART_Collect_Event_Particle: object;
    icon: object;
    sparkle1: object;
    sparkle1_1: object;
    sparkle1: object;
    sparkle2: object;
    sparkle2_1: object;
    sparkle2: object;
    sparkle3: object;
    sparkle3_1: object;
    sparkle3: object;
    icon_1: object;
    sparkle3_copy: object;
    sparkle3_1_copy: object;
    sparkle3: object;
    sparkle2_copy: object;
    sparkle2_1_copy: object;
    sparkle2_copy_1: object;
    sparkle1_copy: object;
    sparkle1_1_copy: object;
    sparkle1_copy_1: object;
  };

  flowData = raw.animations[0];
}
